
import { useSearchParams } from "react-router";
import { useCallback, useMemo } from "react";

export function useQueryParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const getQueryParams = useCallback(() => {
    const params: Record<string, string> = {};

    searchParams.forEach((value, key) => {
      if (value === "undefined" || value === "null" || value === "") return;
      params[key] = value;
    });

    return params;
  }, [searchParams]);

  const setQueryParams = useCallback(
    (params: Record<string, string | number | boolean | undefined>) => {
      const newParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          newParams.set(key, String(value));
        }
      });

      setSearchParams(newParams, { replace: true });
    },
    [setSearchParams]
  );

  const currentQueryParams = useMemo(() => getQueryParams(), [getQueryParams]);

  return {
    getQueryParams,
    setQueryParams,
    currentQueryParams,
  };
}
